
import { Video } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from 'react-i18next';

interface SessionTypeFilterProps {
  sessionType: string;
  onSessionTypeChange: (type: string) => void;
}

const SessionTypeFilter = ({ sessionType, onSessionTypeChange }: SessionTypeFilterProps) => {
  const { t } = useTranslation('practitioners');

  return (
    <div>
      <h3 className="text-sm font-medium mb-3 flex items-center">
        <Video className="mr-2 h-4 w-4 text-amber-600" /> {t('sessionType')}
      </h3>
      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="all"
            checked={sessionType === "all"}
            onCheckedChange={() => onSessionTypeChange("all")}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="all" className="text-sm font-medium cursor-pointer">{t('all')}</label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="virtual"
            checked={sessionType === "virtual"}
            onCheckedChange={() => onSessionTypeChange("virtual")}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="virtual" className="text-sm font-medium cursor-pointer">{t('virtualAvailable')}</label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="in_person"
            checked={sessionType === "in_person"}
            onCheckedChange={() => onSessionTypeChange("in_person")}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="in_person" className="text-sm font-medium cursor-pointer">{t('inPersonOnly')}</label>
        </div>
      </div>
    </div>
  );
};

export default SessionTypeFilter;
